<div class="view-container" (mouseover)="showControls(true)" (mouseleave)="showControls(false)">
    <div [appAgoraVideoPlayer]="trackoptions" [ngClass]="videoClass">
    </div>
    <div class="control-container d-flex flex-row justify-content-center align-items-center" *ngIf="isRemote()">
        <app-meeting-participant-controls [show]="controlsVisible" (pin)="onPin()">
        </app-meeting-participant-controls>
    </div>
</div>